import { PlayerHookType } from '@cbsinteractive/avia-js';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { AbstractAviaPlayerHook } from 'tag/ts/tag/player/adapters/avia/hooks/AbstractAviaPlayerHook';
export class AviaPlayerDaiApiAdHook extends AbstractAviaPlayerHook {
    hookType = PlayerHookType.AD;
    adItem;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPlayerDaiApiAdHook'
        });
        this.tagEventsHandler(this.#onTagEvent, [
            TagEvent.ON_CREATE_PLAYER_SUCCESS
        ]);
    }
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_CREATE_PLAYER_SUCCESS:
                this.removeTagEventsHandler(this.#onTagEvent, this.tag.eventDispatcher, [TagEvent.ON_CREATE_PLAYER_SUCCESS]).then((data) => {
                    this.registerHook();
                });
                break;
        }
    };
    callback = (context) => {
        try {
            const adItem = context?.value;
            const promoPrefixForPremium = 'paramount + - pre-roll - premium plan -';
            if (adItem?.adTitle?.toLowerCase().startsWith(promoPrefixForPremium)) {
                adItem.skippable = true;
                this?.logger?.log('DAI API ad hook callback', 'set adItem to skippable:', adItem);
            }
            else {
                this?.logger?.log('DAI API ad hook callback', 'adItem is not skippable:', adItem);
            }
            this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_PLAYER_HOOK_EXECUTED, this.tag, {
                player: this?.tag?.controller?.playerManager?.player,
                adaptedPlayerInstance: this?.tag?.controller?.playerManager?.playerAdapter?.adaptedPlayerInstance,
                adItem: {
                    skippable: adItem?.skippable
                },
                hook: this
            }, this, this.name));
        }
        catch (error) {
            this?.logger?.warn('DAI API ad hook callback error:', error);
        }
    };
}
